import axios from "axios";
import VueAxios from "vue-axios";

const baseURL = process.env.VUE_APP_API_URL;
axios.defaults.baseURL = baseURL;

export { VueAxios, axios };
